<template>
    <div class="ya-map-filter">
        <template v-for="(item) in filterItems">
            <button class="ya-map-filter__button"
                    :class="`ya-map-filter__button--${item.type}`"
                    v-html="item.name"
                    :key="item.id"
                    @click="someHandler(item)"
            />
        </template>
        <button class="ya-map-filter__show-more" v-if="!state && filterItems.length < allItems.length"
                @click="showAllItems"
        >
            и еще {{allItems.length - filterItems.length}}
        </button>
        <button
            v-if="allItems.length > this.limit"
            class="ya-map-filter__icon-more"
            :class="{'ya-map-filter__icon-more--active': state}"
            @click="showAllItems"/>
    </div>
</template>

<script>
export default {
    name: 'ya-map-filter-button',
    props: {
        allItems: {
            type: Array,
            default: () => [],
            required: true
        },
        selectHandler: {
            type: Function
        }
    },
    emits: ['select-item', 'change-active'],
    data () {
        return {
            state: false,
            limit: 4
        }
    },
    computed: {
        filterItems () {
            if (this.allItems.length > this.limit && !this.state) {
                const array = this.allItems.slice()
                array.splice(this.limit)
                return array
            }
            return this.allItems
        }
    },
    methods: {
        someHandler (item) {
            this.$emit('select-item', item)
        },
        /* Функция для ховера
        updateActive (id, type, status) {
            this.$emit('change-active', {
                id,
                type,
                status
            })
        },
         */
        showAllItems () {
            this.state = !this.state
        }
    }
}
</script>

<style lang="scss">
.ya-map-filter {
    display: flex;
    flex-direction: column;
    padding-left: 42px;
    position: relative;

    @include breakpoint(v-tablet) {
        padding-left: 32px;
    }

    &__icon-more {
        padding: 0;
        border: none;
        background-color: transparent;
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 20px;
        height: 20px;
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.576 12.925a.6.6 0 0 0 .848 0l5-5a.6.6 0 0 0-.848-.849L10 11.652 5.424 7.076a.6.6 0 0 0-.848.849l5 5z' fill='%230077C8'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: center;
        transition: transform 300ms ease;

        &--active {
            transform: rotate(180deg);
        }
    }

    &__show-more {
        font-weight: 400;
        font-size: 12px;
        line-height: 1.4;
        color: $token-colors-gray-35;
        padding: 0 0 0 22px;
        border: none;
        background-color: transparent;
        text-align: start;
        transition: color 300ms ease;

        &:hover {
            color: $token-colors-gray-60;
        }
    }

    &__button {
        padding: 0 0 0 22px;
        border: 0;
        background-color: transparent;
        text-align: start;
        font-weight: 400;
        font-size: 14px;
        line-height: 1.2;
        position: relative;
        transition: opacity 300ms ease;

        &:hover {
            opacity: 0.7;
        }

        &:not(:last-child) {
            margin-bottom: 8px;
        }

        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            display: block;
            width: 14px;
            height: 16px;
            background-repeat: no-repeat;
            background-position: center;
        }

        &--completed {
            &:before {
                background-image: url("data:image/svg+xml,%3Csvg width='14' height='16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='a' fill='%23fff'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m6.933 16 4.903-4.686a6.542 6.542 0 0 0 1.897-3.394 6.355 6.355 0 0 0-.394-3.829 6.702 6.702 0 0 0-2.554-2.974A7.163 7.163 0 0 0 6.933 0a7.163 7.163 0 0 0-3.852 1.117A6.702 6.702 0 0 0 .528 4.09a6.356 6.356 0 0 0-.395 3.83 6.542 6.542 0 0 0 1.898 3.393L6.933 16z'/%3E%3C/mask%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m6.933 16 4.903-4.686a6.542 6.542 0 0 0 1.897-3.394 6.355 6.355 0 0 0-.394-3.829 6.702 6.702 0 0 0-2.554-2.974A7.163 7.163 0 0 0 6.933 0a7.163 7.163 0 0 0-3.852 1.117A6.702 6.702 0 0 0 .528 4.09a6.356 6.356 0 0 0-.395 3.83 6.542 6.542 0 0 0 1.898 3.393L6.933 16z' fill='%233EC011'/%3E%3Cpath d='m11.836 11.314 1.013 1.06-1.013-1.06zM6.933 16 5.92 17.06l1.013.969 1.014-.969L6.933 16zm6.8-8.08 1.436.3-1.436-.3zm-.394-3.829 1.346-.583-1.346.583zm-2.554-2.974-.79 1.236.79-1.236zM.528 4.09l-1.346-.583 1.346.583zm-.395 3.83 1.436-.3-1.436.3zm1.898 3.393-1.014 1.06 1.014-1.06zm8.791-1.06L5.92 14.94l2.027 2.12 4.902-4.686-2.027-2.12zm1.476-2.632a5.076 5.076 0 0 1-1.476 2.632l2.027 2.12a8.01 8.01 0 0 0 2.32-4.155l-2.872-.597zm-.305-2.948c.405.935.51 1.96.304 2.948l2.872.597a7.822 7.822 0 0 0-.484-4.711l-2.692 1.166zM9.996 2.353a5.235 5.235 0 0 1 1.997 2.321l2.692-1.166a8.168 8.168 0 0 0-3.11-3.627l-1.58 2.472zm-3.063-.886c1.096 0 2.162.31 3.063.886l1.579-2.472a8.63 8.63 0 0 0-4.642-1.348v2.934zm-3.062.886a5.696 5.696 0 0 1 3.062-.886v-2.934A8.63 8.63 0 0 0 2.292-.119L3.87 2.353zM1.874 4.674A5.235 5.235 0 0 1 3.87 2.353L2.29-.119A8.168 8.168 0 0 0-.817 3.508l2.692 1.166zm-.305 2.948a4.89 4.89 0 0 1 .305-2.948L-.818 3.508a7.823 7.823 0 0 0-.485 4.711l2.872-.597zm1.475 2.632A5.076 5.076 0 0 1 1.57 7.622l-2.872.597a8.01 8.01 0 0 0 2.32 4.155l2.027-2.12zm4.903 4.686-4.903-4.686-2.027 2.12L5.92 17.06l2.027-2.12z' fill='%233EC011' mask='url(%23a)'/%3E%3Ccircle cx='7.04' cy='6.88' r='2.4' fill='%23fff'/%3E%3C/svg%3E");

            }
        }

        &--in-process {
            &:before {
                background-image: url("data:image/svg+xml,%3Csvg width='14' height='16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='a' fill='%23fff'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m6.933 16 4.903-4.686a6.542 6.542 0 0 0 1.897-3.394 6.355 6.355 0 0 0-.394-3.829 6.702 6.702 0 0 0-2.554-2.974A7.163 7.163 0 0 0 6.933 0a7.163 7.163 0 0 0-3.852 1.117A6.702 6.702 0 0 0 .528 4.09a6.356 6.356 0 0 0-.395 3.83 6.542 6.542 0 0 0 1.898 3.393L6.933 16z'/%3E%3C/mask%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m6.933 16 4.903-4.686a6.542 6.542 0 0 0 1.897-3.394 6.355 6.355 0 0 0-.394-3.829 6.702 6.702 0 0 0-2.554-2.974A7.163 7.163 0 0 0 6.933 0a7.163 7.163 0 0 0-3.852 1.117A6.702 6.702 0 0 0 .528 4.09a6.356 6.356 0 0 0-.395 3.83 6.542 6.542 0 0 0 1.898 3.393L6.933 16z' fill='%23D7C316'/%3E%3Cpath d='m11.836 11.314 1.013 1.06-1.013-1.06zM6.933 16 5.92 17.06l1.013.969 1.014-.969L6.933 16zm6.8-8.08 1.436.3-1.436-.3zm-.394-3.829 1.346-.583-1.346.583zm-2.554-2.974-.79 1.236.79-1.236zM.528 4.09l-1.346-.583 1.346.583zm-.395 3.83 1.436-.3-1.436.3zm1.898 3.393-1.014 1.06 1.014-1.06zm8.791-1.06L5.92 14.94l2.027 2.12 4.902-4.686-2.027-2.12zm1.476-2.632a5.076 5.076 0 0 1-1.476 2.632l2.027 2.12a8.01 8.01 0 0 0 2.32-4.155l-2.872-.597zm-.305-2.948c.405.935.51 1.96.304 2.948l2.872.597a7.822 7.822 0 0 0-.484-4.711l-2.692 1.166zM9.996 2.353a5.235 5.235 0 0 1 1.997 2.321l2.692-1.166a8.168 8.168 0 0 0-3.11-3.627l-1.58 2.472zm-3.063-.886c1.096 0 2.162.31 3.063.886l1.579-2.472a8.63 8.63 0 0 0-4.642-1.348v2.934zm-3.062.886a5.696 5.696 0 0 1 3.062-.886v-2.934A8.63 8.63 0 0 0 2.292-.119L3.87 2.353zM1.874 4.674A5.235 5.235 0 0 1 3.87 2.353L2.29-.119A8.168 8.168 0 0 0-.817 3.508l2.692 1.166zm-.305 2.948a4.89 4.89 0 0 1 .305-2.948L-.818 3.508a7.823 7.823 0 0 0-.485 4.711l2.872-.597zm1.475 2.632A5.076 5.076 0 0 1 1.57 7.622l-2.872.597a8.01 8.01 0 0 0 2.32 4.155l2.027-2.12zm4.903 4.686-4.903-4.686-2.027 2.12L5.92 17.06l2.027-2.12z' fill='%23D7C316' mask='url(%23a)'/%3E%3Ccircle cx='7.04' cy='6.88' r='2.4' fill='%23fff'/%3E%3C/svg%3E");
            }
        }

        &--coming-soon {
            &:before {
                background-image: url("data:image/svg+xml,%3Csvg width='14' height='16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='a' fill='%23fff'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m6.933 16 4.903-4.686a6.542 6.542 0 0 0 1.897-3.394 6.355 6.355 0 0 0-.394-3.829 6.702 6.702 0 0 0-2.554-2.974A7.163 7.163 0 0 0 6.933 0a7.163 7.163 0 0 0-3.852 1.117A6.702 6.702 0 0 0 .528 4.09a6.356 6.356 0 0 0-.395 3.83 6.542 6.542 0 0 0 1.898 3.393L6.933 16z'/%3E%3C/mask%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='m6.933 16 4.903-4.686a6.542 6.542 0 0 0 1.897-3.394 6.355 6.355 0 0 0-.394-3.829 6.702 6.702 0 0 0-2.554-2.974A7.163 7.163 0 0 0 6.933 0a7.163 7.163 0 0 0-3.852 1.117A6.702 6.702 0 0 0 .528 4.09a6.356 6.356 0 0 0-.395 3.83 6.542 6.542 0 0 0 1.898 3.393L6.933 16z' fill='%230290F0'/%3E%3Cpath d='m11.836 11.314 1.013 1.06-1.013-1.06zM6.933 16 5.92 17.06l1.013.969 1.014-.969L6.933 16zm6.8-8.08 1.436.3-1.436-.3zm-.394-3.829 1.346-.583-1.346.583zm-2.554-2.974-.79 1.236.79-1.236zM.528 4.09l-1.346-.583 1.346.583zm-.395 3.83 1.436-.3-1.436.3zm1.898 3.393-1.014 1.06 1.014-1.06zm8.791-1.06L5.92 14.94l2.027 2.12 4.902-4.686-2.027-2.12zm1.476-2.632a5.076 5.076 0 0 1-1.476 2.632l2.027 2.12a8.01 8.01 0 0 0 2.32-4.155l-2.872-.597zm-.305-2.948c.405.935.51 1.96.304 2.948l2.872.597a7.822 7.822 0 0 0-.484-4.711l-2.692 1.166zM9.996 2.353a5.235 5.235 0 0 1 1.997 2.321l2.692-1.166a8.168 8.168 0 0 0-3.11-3.627l-1.58 2.472zm-3.063-.886c1.096 0 2.162.31 3.063.886l1.579-2.472a8.63 8.63 0 0 0-4.642-1.348v2.934zm-3.062.886a5.696 5.696 0 0 1 3.062-.886v-2.934A8.63 8.63 0 0 0 2.292-.119L3.87 2.353zM1.874 4.674A5.235 5.235 0 0 1 3.87 2.353L2.29-.119A8.168 8.168 0 0 0-.817 3.508l2.692 1.166zm-.305 2.948a4.89 4.89 0 0 1 .305-2.948L-.818 3.508a7.823 7.823 0 0 0-.485 4.711l2.872-.597zm1.475 2.632A5.076 5.076 0 0 1 1.57 7.622l-2.872.597a8.01 8.01 0 0 0 2.32 4.155l2.027-2.12zm4.903 4.686-4.903-4.686-2.027 2.12L5.92 17.06l2.027-2.12z' fill='%230290F0' mask='url(%23a)'/%3E%3Ccircle cx='7.04' cy='6.88' r='2.4' fill='%23fff'/%3E%3C/svg%3E");
            }
        }
    }
}
</style>
